import * as React from 'react';
import { Calendar, ICalendarValue } from '../Calendar';
import { CalendarPosition, DateInputStyled, DateInputSubstrate, DisableBodyScroll } from './DateInput.styles';
import { Grid } from '../Grid';
import { Button } from '../Button';
import ReactDOM from 'react-dom';

export interface IDateInputCalendarPopupProps {
  attachPortalInsideContainer: boolean;
  calendarAnchor: { x: number; y: number };
  calendarPosition: CalendarPosition;
  zIndex?: number;
  toggleCalendar: () => void;
  setCalendarValue: (calendarValue: ICalendarValue) => void;
  onClickHandler: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dateISO?: string | null;
  maxDate?: string;
  minDate?: string;
  highlightDate?: 'today' | string;
  calendarContent?: React.ReactNode;
}

export const DateInputCalendarPopup: React.FC<IDateInputCalendarPopupProps> = ({
  attachPortalInsideContainer,
  calendarAnchor,
  calendarPosition,
  zIndex,
  toggleCalendar,
  setCalendarValue,
  onClickHandler,
  dateISO,
  maxDate,
  minDate,
  highlightDate,
  calendarContent,
}) => {
  return (
    <>
      <DisableBodyScroll />
      <DateInputSubstrate onClick={toggleCalendar} zIndex={zIndex} />
      {!attachPortalInsideContainer &&
        ReactDOM.createPortal(
          <DateInputStyled
            anchor={calendarAnchor}
            position={calendarPosition}
            zIndex={typeof zIndex === 'number' ? zIndex + 1 : undefined}
          >
            <Calendar
              inCard={true}
              inputDate={dateISO}
              minDay={minDate}
              maxDay={maxDate}
              monthControlType={'control'}
              onChange={setCalendarValue}
              yearControlType={'control'}
              highlightDate={highlightDate}
            >
              {dateISO ? (
                <Grid>
                  <Button intent={'ghost'} isInline onClick={onClickHandler} type="button">
                    Clear date
                  </Button>
                </Grid>
              ) : null}
              {calendarContent}
            </Calendar>
          </DateInputStyled>,
          document.body
        )}
      {attachPortalInsideContainer && (
        <DateInputStyled
          anchor={calendarAnchor}
          position={calendarPosition}
          zIndex={typeof zIndex === 'number' ? zIndex + 1 : undefined}
        >
          <Calendar
            inCard={true}
            inputDate={dateISO}
            minDay={minDate}
            maxDay={maxDate}
            monthControlType={'control'}
            onChange={setCalendarValue}
            yearControlType={'control'}
            highlightDate={highlightDate}
          >
            {dateISO ? (
              <Grid>
                <Button intent={'ghost'} isInline onClick={onClickHandler} type="button">
                  Clear date
                </Button>
              </Grid>
            ) : null}
            {calendarContent}
          </Calendar>
        </DateInputStyled>
      )}
    </>
  );
};
